/**
 * Converts an object to query parameters string
 * @param {Object} params - The object to convert
 * @returns {string} Query parameters string
 */
export const objectToQueryParams = (params) => {
  if (!params || typeof params !== 'object') {
    return '';
  }

  return Object.entries(params)
    .filter(([key, value]) => value !== undefined && value !== null && value !== '')
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
};
